module.exports = __webpack_public_path__ + "img/yunyingfenxi.46bd6326.png";